import { Injectable } from '@angular/core';
import {HttpService} from './http.service';
import {Observable} from 'rxjs';
import {environment} from "@shared-environments/environment";
@Injectable()
export class FriendService {

    private getFriendsUrl= '/friend/front/list';
    private addInvitationsUrl = 'friend/invitations-list';
    private addFriendUrl = '/friend/add';
    private cancelFriendReqUrl = '/friend/cancel/:inviteUserId';
    private answerInvitationUrl = '/friend/answer/:invitationId';
    private answerInvitationByNotifyUrl = '/friend/answer/by-notify/:notificationId';
    private deleteUrl = '/friend/:id';
    ////

    constructor(private networkHelper: HttpService) { }

    getItems(pagination:any, filter:any): Observable<any> {
        return this.networkHelper.get(environment.apiURL + this.getFriendsUrl, {...pagination, ...filter});
    }
    getInvitationsList(pagination:any, filter:any): Observable<any> {
        return this.networkHelper.get(environment.apiURL + this.addInvitationsUrl, {...pagination, ...filter});
    }

    add(data:any): Observable<any> {
        return this.networkHelper.post(environment.apiURL +
            this.addFriendUrl, data);
    }

    cancelFriendReq(inviteUserId:string, data: any):any{
      return this.networkHelper.post(environment.apiURL +
        this.cancelFriendReqUrl.replace(':inviteUserId',inviteUserId), data);
    }

    delete(id:any): Observable<any> {
        return this.networkHelper.del(environment.apiURL +
            this.deleteUrl.replace(':id', id));
    }

    answerToInvite(id:any, data:any): Observable<any> {
        return this.networkHelper.put(environment.apiURL +
            this.answerInvitationUrl.replace(':invitationId',id), data);
    }

    answerInvitationByNotify(notificationId: string, data: any){
      return this.networkHelper.put(environment.apiURL +
        this.answerInvitationByNotifyUrl.replace(':notificationId',notificationId), data);
    }


}
